import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useHiringInstantPay() {
  return useCbhFlag(CbhFeatureFlag.HIRING_INSTANT_PAY, {
    defaultValue: {
      enabled: false,
    },
  });
}
